/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TubApiUrlResponse } from '../models/tub-api-url-response';
@Injectable({
  providedIn: 'root',
})
class RegionInteroperabilityService extends __BaseService {
  static readonly RegionsGetRegionsPath = '/regions';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * get TUB REST API base URL for client region
   *
   * Retrieve a list of all available regions.
   * @param CF-IPCountry the ISO 3166-1 alpha-2 country code for the clients IP, as passed in by CloudFlare - please note that Cloudflare will override this header if it is explicitly set, so your input will be ignored unless running TUB locally
   * @return Ok
   */
  RegionsGetRegionsResponse(CFIPCountry?: string): __Observable<__StrictHttpResponse<TubApiUrlResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (CFIPCountry != null) __headers = __headers.set('CF-IPCountry', CFIPCountry.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/regions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TubApiUrlResponse>;
      })
    );
  }
  /**
   * get TUB REST API base URL for client region
   *
   * Retrieve a list of all available regions.
   * @param CF-IPCountry the ISO 3166-1 alpha-2 country code for the clients IP, as passed in by CloudFlare - please note that Cloudflare will override this header if it is explicitly set, so your input will be ignored unless running TUB locally
   * @return Ok
   */
  RegionsGetRegions(CFIPCountry?: string): __Observable<TubApiUrlResponse> {
    return this.RegionsGetRegionsResponse(CFIPCountry).pipe(
      __map(_r => _r.body as TubApiUrlResponse)
    );
  }
}

module RegionInteroperabilityService {
}

export { RegionInteroperabilityService }
